import { Container, Typography } from "@mui/material";
import Section from "./Section";

function About() {

  return (
    <Section>
      <Container maxWidth="md" sx={{
        marginBottom: 3,
      }}>
        <Typography variant="h5" gutterBottom fontWeight='bold'>
          O mnie
        </Typography>
        <Typography variant="body2" textAlign={"justify"}>
          Jestem architektem z doświadczeniem w projektach kubaturowych - od dużych osiedli mieszkaniowych po obiekty użyteczności publicznej.
          Pracuję z wykorzystaniem technologii BIM, prowadzę zespoły projektowe i koordynuję inwestycje wielobranżowe.
          <br />
          <br />
          Coraz bardziej jednak zależy mi na tworzeniu architektury, która naprawdę służy człowiekowi - niezależnie od skali.
          <br />
          Takiej, która współgra z życiem, wspiera je, rozwija i zaprasza do bycia w kontakcie ze sobą i światem.
          Marzę o projektach, które mają duszę. O budynkach - małych i dużych - będących czymś więcej niż formą.
          Takich, które stają się jednym organizmem z ludźmi, naturą i codziennością.
        </Typography>
      </Container>
    </Section>
  );
}

export default About;
